export const FROST_ACTIVATION_MODE = 'web'
export const REPLY_Y_ACTIVATION_MODE = 'text'
